import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DATA_FEATURE_KEY, DataState } from './data.reducer';

export const selectData = createFeatureSelector<Readonly<DataState>>(DATA_FEATURE_KEY);

export const selectDataDarkMode = createSelector(selectData, (state) => state.darkMode);

export const selectDataSidebarCollapsed = createSelector(selectData, (state) => state.sidebarCollapsed);

export const selectDataTranslations = createSelector(selectData, (state) => state.translations);
